import { Injectable } from '@angular/core';
import { RmsPulldownService } from './rms-pulldown.service';
import { RmsPulldownRef } from '../custom-modules/rms-module/rms-pulldown/rms-pulldown-ref';
import { CreateTicketComponent } from '../components/royal-ticketing/create-ticket/create-ticket.component';
@Injectable({providedIn:'root'})
export class RtsCreatorService {
 private active?:RmsPulldownRef<{TicketID:number}>;
 constructor(private pulldown:RmsPulldownService){}
 open(){
  if(this.active)return this.active;
  const ref=this.pulldown.open<CreateTicketComponent,undefined,{TicketID:number}>(CreateTicketComponent,{
   title:'Royal Ticketing · Create ticket',width:'900px',maxWidth:'96vw',maxHeight:'92vh',top:'0',
   closeOnBackdropClick:false,closeOnEscape:false
  });
  this.active=ref;
  ref.afterClosed().subscribe(()=>{if(this.active===ref)this.active=undefined;});
  return ref;
 }
}
